import script from "./TaskCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCard.vue?vue&type=script&setup=true&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=46bf031e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bf031e"]])

export default __exports__